import React from "react";
import {Link} from "gatsby";

export function Footer() {
  return (
    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          <strong>Offset me!</strong> by{" "}
          <a href="http://www.suchanek.io">Jakub Suchánek</a> and{" "}
          <a href="https://www.lawrencejb.com">Lawrence Berry</a>.
        </p>
      </div>
    </footer>
  );
}
